var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41602 6.625L12.6406 2.44141L13.502 1.58008C13.625 1.45703 13.625 1.25195 13.502 1.08789L12.5996 0.185547C12.4355 0.0625 12.2305 0.0625 12.1074 0.185547L7.0625 5.27148L1.97656 0.185547C1.85352 0.0625 1.64844 0.0625 1.48438 0.185547L0.582031 1.08789C0.458984 1.25195 0.458984 1.45703 0.582031 1.58008L5.66797 6.625L0.582031 11.7109C0.458984 11.834 0.458984 12.0391 0.582031 12.2031L1.48438 13.1055C1.64844 13.2285 1.85352 13.2285 1.97656 13.1055L7.0625 8.01953L11.2461 12.2441L12.1074 13.1055C12.2305 13.2285 12.4355 13.2285 12.5996 13.1055L13.502 12.2031C13.625 12.0391 13.625 11.834 13.502 11.7109L8.41602 6.625Z",
    fill: "#00095B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlue);
export default __webpack_public_path__ + "static/media/close-blue.a622ea696546c38a1c4f9a657203821d.svg";
export { ForwardRef as ReactComponent };